import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { Globals } from '../../../app/app.globals';
import { SignupForm, LoginForm, ContactForm,ResendForm ,ChangePasswordForm } from '../../../models';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';

@Injectable()
export class AuthService {
    public headers: Headers;
    public checkDefaultPackage: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    
    constructor(private http: Http, private globals: Globals, private router: Router) {
        this.headers = new Headers();
        this.headers.append('Content-Type', 'application/json;charset=utf-8');
        this.headers.append('Accept', 'application/json, text/plain, */*');
        this.headers.append('Authorization', 'Bearer undefined');
    }

    login(model: LoginForm) {
        return this.http.post(this.globals.apiEndpoint + 'api/login/', JSON.stringify(model), { headers: this.headers })
            .map((res) => {
                let response = res.json();
                localStorage.setItem('auth_token', response.access_token);
                localStorage.setItem('user_id', response.user_id);
                localStorage.setItem('username', response.username);
                localStorage.setItem('status', response.status);
                localStorage.setItem('referral_limit', response.referral_limit);
                localStorage.setItem('package', response.package);
                return response;
            });
    }

    resendEmail(model: ResendForm) {
        return this.http.post(this.globals.apiEndpoint + 'api/resend-confirmation-email/', JSON.stringify(model), { headers: this.headers });
    }

    signup(model: SignupForm) {
        return this.http.post(this.globals.apiEndpoint + 'api/signup/', JSON.stringify(model), { headers: this.headers });
    }

    failedReferral(model: SignupForm) {
        return this.http.post(this.globals.apiEndpoint + 'api/failed-referral/', JSON.stringify(model), { headers: this.headers });
    }

    verifySignup(token: string) {
        return this.http.post(this.globals.apiEndpoint + 'api/verify-account/?token=' + token, {});
    }

    resendComfirmEmail(email: string) {
        return this.http.get(this.globals.apiEndpoint + 'api/resend-confirmation/?email=' + email, {});
    }

    isUserLoggedIn(): boolean {
        return (!!localStorage.getItem('auth_token'));
    }

    isReferralLimit(): boolean {
        return (!!localStorage.getItem('referral_limit'))?(parseInt(localStorage.getItem('referral_limit'))>0?true:false):false;
    }

    validatePasswordResetToken(token: string) {
        return this.http.get(this.globals.domain + 'site/reset-password?token=' + token);
    }

    sendPasswordResetRequest(screenName: string) {
        return this.http.post(this.globals.apiEndpoint + 'api/request-password-reset/', { screenname: screenName, new: true }, { headers: this.headers });
    }

    resetPassword(token: string, newPassword: string) {
        return this.http.post(this.globals.apiEndpoint + 'api/reset-password/?token=' + token, { password: newPassword });
    }

    sendScreennameresetRequest(email: string) {
        return this.http.post(this.globals.apiEndpoint + 'api/forgot-screenname/', { email: email, json: true }, { headers: this.headers });
    }

    getLoggedInUserId() {
        return (!!localStorage.getItem('user_id')) ? localStorage.getItem('user_id') : false;
    }

    changePassword(model: ChangePasswordForm) {
        let headers = new Headers();
        headers.append('Content-Type', 'application/json;charset=utf-8');
        headers.append('Accept', 'application/json, text/plain, */*');
        headers.append('Authorization', 'Bearer ' + localStorage.getItem('auth_token'));
        return this.http.post(this.globals.apiEndpoint + 'api/changepassword/', JSON.stringify(model), { headers: headers });
    }

    logOut() {
        this.http.get(this.globals.apiEndpoint + 'api/logout?token=' + localStorage.getItem('auth_token')).subscribe();
        let user_id = localStorage.getItem('user_id');

        localStorage.removeItem('auth_token');
        localStorage.removeItem('user_id');
        localStorage.removeItem(user_id+'_'+'tracker');
        localStorage.removeItem('tracker');
        localStorage.removeItem('listenCount');
        localStorage.removeItem('username');
        localStorage.removeItem('status');
        localStorage.removeItem('searchPreferences');
        localStorage.removeItem('referral_limit');
        localStorage.removeItem('package');
        localStorage.removeItem('songDetail');
        localStorage.removeItem('playlistDetail');

        this.router.navigate(['']);
    }

    postContactForm(model: ContactForm) {
        return this.http.post(this.globals.apiEndpoint + 'api/contact', JSON.stringify(model));
    }

    getNewCaptcha() {
        return this.http.get(this.globals.domain + 'site/captcha?refresh=1');
    }
}



// WEBPACK FOOTER //
// ./src/app/api/services/auth-service.ts